import { inject, Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SettingsService } from '../services/settings.service';

@Pipe({
  name: 'backgroundImage',
  standalone: true,
})
export class BackgroundImagePipe implements PipeTransform {
  settingsService = inject(SettingsService);
  adminDomain = environment.imagePath;
  isMobile = false;

  transform(imageUrl: string, imageWidth: number, imageRatio: number) {
    // console.log('imageUrl :>> ', imageUrl);
    // console.log('imageWidth :>> ', imageWidth);
    // console.log('image.ImageRatio :>> ', image.ImageRatio);
    // console.log('image :>> ', image);
    // console.log('mode :>> ', mode);
    // console.log('imageHeight :>> ', imageHeight);
    // console.log('fixedHeight :>> ', fixedHeight);

    this.isMobile = this.settingsService.getMobileStatus();
    const isTablet = this.settingsService.getTabletStatus();

    if (!imageUrl) {
      return '';
    }

    // fix mobile images
    if (this.isMobile) {
      if (imageWidth > 390) {
        imageWidth = 390;
      }
    } else if (isTablet) {
      imageWidth = 989;
    }

    let size = '';
    if (imageWidth !== 0 && imageRatio) {
      const imagePath = environment.imgFxActive
        ? environment.imgFxDomain.replace('{mode}', 'fill.webp') + imageUrl
        : environment.apiDomain + 'upload/media/' + imageUrl;

      size = imageWidth + 'x' + Math.floor(imageWidth * imageRatio);

      return imagePath.replace('{size}', size);
    }

    return imageUrl.substr(0, 4) === 'http'
      ? imageUrl
      : this.adminDomain + imageUrl;
  }
}
